import { BannerVariant } from '@glow/entity-types'
import classNames from 'classnames'
import i18next from 'i18next'
import { HTMLAttributes } from 'react'
import type { IconName } from '../icon'
import { IconFa } from '../icon-fa'
import { PlainButton } from '../plain-button'
import styles from './Banner.module.css'

interface BannerProps extends HTMLAttributes<HTMLDivElement> {
  closeable?: boolean
  onClose?: () => void
  variant?: BannerVariant
  defaultIcon?: boolean
}
export const Banner = ({
  children,
  closeable,
  onClose,
  variant = 'WARNING',
  defaultIcon,
  className,
  ...props
}: BannerProps) => {
  const defaultIconName: IconName =
    variant === 'WARNING' ? 'exclamation-circle' : variant === 'ERROR' ? 'exclamation-triangle' : 'info-circle'
  return (
    <div {...props} className={classNames(styles.banner, styles[variant], className)}>
      <div className={styles.text}>
        {defaultIcon && <IconFa icon={['fas', defaultIconName]} className="mr-4" />}
        {children}
      </div>
      {closeable ? (
        <PlainButton
          type="button"
          className={classNames('h-8 w-8 min-w-8 rounded-xs', styles.closeLink)}
          aria-label={i18next.t('glow.close')}
          onClick={onClose}
        >
          <IconFa icon={['far', 'xmark']} />
        </PlainButton>
      ) : null}
    </div>
  )
}
